import React from 'react';
import { Outlet } from 'react-router-dom';
import { UnifiedBreadcrumbBar } from './components/UnifiedBreadcrumbBar';
import DesktopNavigation from './components/DesktopNavigation';
import { MobileTopBar } from './components/MobileTopBar';
import { MobileDrawer } from './components/MobileDrawer';
import styles from './mainLayout.module.scss';
import { Box, Paper, useTheme, useMediaQuery, Toolbar } from '@mui/material';
import { useUIStore } from '../stores/uiStore';
import { PageActionsProvider } from '../contexts/PageActionsContext';

export const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { mobileDrawerOpen, setMobileDrawerOpen } = useUIStore();

  const handleMobileDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const handleMobileDrawerClose = () => {
    setMobileDrawerOpen(false);
  };

  if (isMobile) {
    // Mobile Layout
    return (
      <PageActionsProvider>
        <Box className={styles.mobileLayout}>
          <MobileTopBar onMenuClick={handleMobileDrawerToggle} />
          <MobileDrawer open={mobileDrawerOpen} onClose={handleMobileDrawerClose} />

          {/* Mobile Content */}
          <Box className={styles.mobileContentContainer}>
            {/* Add spacing for the fixed top bar */}
            <Toolbar />
            <UnifiedBreadcrumbBar />
            <Paper
              elevation={0}
              className={styles.mobileContent}
              sx={(theme) => ({
                mb: 0,
                mr: 0,
                mt: 0,
                ml: 0,
                backgroundColor:
                  theme.palette.mode === 'light' ? '#ffffff' : theme.palette.grey[900],
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.015), 0px 2px 8px rgba(0, 0, 0, 0.012)',
              })}
            >
              <Outlet />
            </Paper>
          </Box>
        </Box>
      </PageActionsProvider>
    );
  }

  // Desktop Layout
  return (
    <PageActionsProvider>
      <Box className={styles.mainLayout}>
        <DesktopNavigation
          items={[
            { label: 'Home', href: '/' },
            { label: 'Manage', href: '/app/manage' },
          ]}
        />
        <div className={styles.mainContentContainer}>
          <UnifiedBreadcrumbBar />
          <Box className={styles.mainContent}>
            <Outlet />
          </Box>
        </div>
      </Box>
    </PageActionsProvider>
  );
};
